




























import { Component, Vue, Mixins, Prop, Watch } from "vue-property-decorator";
import { Swiper, SwiperOptions } from "swiper/bundle";
import { AA } from '@/lib/mixin';
import {aplusAdClick, aplusExp} from "../lib/qtLIb"


@Component
export default class Carousel extends Mixins(Vue, AA) {
  @Prop() readonly catalogIndex!: number;
  @Prop() readonly tabIndex!: number;

  swiper?: Swiper;
  intervalID = 0;
  exportList: string[] = [];
  get items(): Array<Article> {
    return this.$store.getters.bannerArticlesByIndex(this.catalogIndex);
  }

  goto(s: number) {
    const item = this.items[s] as Article;
    const eventName = this.tabIndex === 0 ? 'slhp_adspace_clk' : 'sehp_adspace_clk'
    aplusAdClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: eventName,
      // eslint-disable-next-line @typescript-eslint/camelcase
      adspace_rank_id: s,
      // eslint-disable-next-line @typescript-eslint/camelcase
      adspace_name: item.title
    })
    this.tracking({ isAction: true, pageName: 'Home', actionName: `Banner_${item.title}` })
    console.log(eventName)
    if (item.url === 'https://zhuxingrongyao') {
      return;
    }
    window.location.href = item.url;
  }

  @Watch('tabIndex')
  onTabIndexChanged(val: number) {
    if (val === this.catalogIndex) {
      this.nextSlide(-1, 0);
      setTimeout(() => {
        this.nextSlide(1, 0);
      }, 100);
    }
  }



  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const data = this
    const swiperParams: SwiperOptions = {
      observer: true,
      observeSlideChildren: true,
      effect: 'slide',
      pagination: {
        el: `.swiper-pagination-${this.catalogIndex}`,
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      nested: true,
      on: {
        init(s: any) {
          window.console.log('init')
          if (data.items[0] !== null && data.items[0] !== undefined){
            const eventName = data.tabIndex == 0 ? 'slhp_adspace_exp' : 'sehp_adspace_exp';
            aplusExp({
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_name: eventName,
              // eslint-disable-next-line @typescript-eslint/camelcase
              adspace_rank_id: 1,
              // eslint-disable-next-line @typescript-eslint/camelcase
              adspace_name: data.items[0].title
            })
            data.exportList.push(data.items[s.activeIndex].title)
          }
          s.emit('transitionEnd');//在初始化时触发一次transitionEnd事件，需要先设置transitionEnd
        },
        slideChange(s: any) {
          if (data.exportList.indexOf(data.items[s.activeIndex].title) === -1) {
            const eventName = data.tabIndex == 0 ? 'slhp_adspace_exp' : 'sehp_adspace_exp';
            aplusExp({
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_name: eventName,
              // eslint-disable-next-line @typescript-eslint/camelcase
              adspace_rank_id: s.activeIndex + 1,
              // eslint-disable-next-line @typescript-eslint/camelcase
              adspace_name: data.items[s.activeIndex].title
            })
            data.exportList.push(data.items[s.activeIndex].title)
          }
        }
      }
    };
    this.swiper = new Swiper(`.swiper-container-${this.catalogIndex}`, swiperParams);
    this.intervalID = setInterval(this.nextSlide, 4000);
  }

  nextSlide(delta = 1, speed = 500) {
    if (this.swiper && this.items.length > 0 && this.catalogIndex === this.tabIndex) {
      let nextIndex = this.swiper.realIndex + delta;
      if (nextIndex > 0) {
        nextIndex = nextIndex % this.items.length;
      } else if (nextIndex < 0) {
        nextIndex = this.items.length + nextIndex;
      }
      this.swiper.slideTo(nextIndex, speed, false);
    }
  }

  beforeDestroy() {
    clearInterval(this.intervalID);
    this.swiper?.destroy();
  }

  launchError(e: any) {
    console.error('launchError:', e)
  }

  launchSuccess(index: number) {
    this.goto(index);
  }
}
